import React from 'react';
import './Alcance_css.css';
import * as GiIcons from 'react-icons/gi';
import * as BsIcons from 'react-icons/bs';

function Alcance(props) {
    
  return (
    <div>
      <label className='container__alcance'>
        <GiIcons.GiFactory style={{color:'#1010C5',width:'1em',height:'1em',position:'relative', top:'-4px'}}/>
        Alcance #1. Emisiones de CO2 que son producidas en o porla empresa, directamente. Ej. Carros de la compañía.
        <input type='radio' value='1' defaultChecked checked={props.checked} onChange={props.onChange} name='alcance' ></input>
        <span className='checkmark'></span>
      </label>
      <label className='container__alcance'>
        <BsIcons.BsLightning style={{color:'#1010C5',width:'1em',height:'1em',position:'relative', top:'-4px'}}/>
        Alcance #2. Emisiones provenientes de consumo eléctrico de la empresa. Ej Computadores de oficina.
        <input type='radio' value='2' checked={props.checked} onChange={props.onChange} name='alcance' ></input>
        <span className='checkmark'></span>
      </label>
      <label className='container__alcance'>
        <GiIcons.GiBattleship style={{color:'#1010C5',width:'1em',height:'1em',position:'relative', top:'-4px'}}/>
        Alcance #3. Emisiones producidas por terceros, originados por acciones propias. Ej Transporte de mercancia.
        <input type='radio' value='3' checked={props.checked} onChange={props.onChange} name='alcance' ></input>
        <span className='checkmark'></span>
      </label>
    </div>
  )
}

export { Alcance };
